import { ITermoNotificacao } from "@/interfaces/ITermoNotificacao";
import { createAction } from "@reduxjs/toolkit";

const add = createAction(
  "TERMO_NOTIFICACAO/add",
  (item: ITermoNotificacao) => ({
    payload: { item },
  })
);

const remove = createAction(
  "TERMO_NOTIFICACAO/remove",
  (offlineId: number) => ({
    payload: { offlineId },
  })
);

const update = createAction(
  "TERMO_NOTIFICACAO/update",
  (item: ITermoNotificacao) => ({
    payload: { item },
  })
);

export const termoNotificacaoAction = {
  add,
  remove,
  update,
};
